<span class="jip-version-info">
  V {{ version || '[Version Number]' }}
</span>
